
import {
  CodeTypeSetting,
  ConfigId,
  KeyenceModule,
  ScanResult,
  defaultCodeTypeSetting,
  isKeyenceEnterpriseBrowser,
} from '@/utils/keyenceHT/keyenceModules'
import { Options, Vue } from 'vue-class-component'
import { Prop, PropSync } from 'vue-property-decorator'
import IconScanQR from '../svg/IconScanQR.vue'

@Options({
  components: {
    IconScanQR,
  },
  emits: ['update:confirm'],
})
export default class ListStringScanButton extends Vue {
  @PropSync('loading', { type: Boolean }) _loading!: boolean
  @Prop({ type: String, default: 'add' }) readonly scanMode!: 'add' | 'remove'
  isScanning = false
  isScanningWithKeyenceHT = false
  valueCode = ''
  scanIntervalId: number | null = null
  scanningStateFetchIntervalId: number | null = null
  backupCodeTypeSetting: CodeTypeSetting = defaultCodeTypeSetting
  private readonly onWindowMouseUp = () => {
    this.stopScan()
  }

  confirm() {
    this.$emit('update:confirm', this.valueCode.trim())
  }

  get isEnterpriseBrowser(): boolean {
    return isKeyenceEnterpriseBrowser()
  }

  async mounted() {
    if (isKeyenceEnterpriseBrowser() && KeyenceModule && KeyenceModule.Scanner) {
      this.backupCodeTypeSetting = KeyenceModule.Scanner.getConfig(ConfigId.CodeType) as CodeTypeSetting
      KeyenceModule.Scanner.setConfig(ConfigId.CodeType, defaultCodeTypeSetting)

      KeyenceModule.Scanner.clearReadCallback()
      KeyenceModule.Scanner.setReadCallback('keyenceHandyTerminalScanResultCallback')
    }

    window.keyenceHandyTerminalScanResultCallback = async (result: ScanResult) => {
      if (result.mDecodeResult !== 'SUCCESS') {
        return
      }

      const resultString =
        typeof result.mStringData === 'string' ? result.mStringData : result.mStringData[0].toString()
      const scannedText = resultString.trim()

      this.handleScanResult(scannedText)
    }

    this.scanningStateFetchIntervalId = window.setInterval(this.fetchScanningStateFromKeyenceHT.bind(this), 100)
  }

  fetchScanningStateFromKeyenceHT() {
    if (isKeyenceEnterpriseBrowser() && KeyenceModule && KeyenceModule.Scanner) {
      this.isScanningWithKeyenceHT = KeyenceModule.Scanner.isReading() as boolean
    }
  }

  handleScanResult(plainText: string) {
    this.valueCode = plainText
    if (plainText.trim()) {
      this.confirm()
    }
  }

  get isScanningState(): boolean {
    return this.isScanning || this.isScanningWithKeyenceHT
  }

  async startScan() {
    if (isKeyenceEnterpriseBrowser() && KeyenceModule && KeyenceModule.Scanner) {
      KeyenceModule.Scanner.startRead()
      this.isScanning = true
    }

    window.addEventListener('mouseup', this.onWindowMouseUp)
  }

  async stopScan() {
    if (isKeyenceEnterpriseBrowser() && KeyenceModule && KeyenceModule.Scanner) {
      KeyenceModule.Scanner.stopRead()
      this.isScanning = false
    }
    window.removeEventListener('mouseup', this.onWindowMouseUp)
  }

  unmounted() {
    // Clean up interval on unmount
    if (this.scanIntervalId !== null) {
      clearInterval(this.scanIntervalId)
      this.scanIntervalId = null
    }

    window.removeEventListener('mouseup', this.onWindowMouseUp)
    if (this.scanningStateFetchIntervalId !== null) {
      window.clearInterval(this.scanningStateFetchIntervalId)
      this.scanningStateFetchIntervalId = null
    }

    if (isKeyenceEnterpriseBrowser() && KeyenceModule && KeyenceModule.Scanner) {
      KeyenceModule.Scanner.clearReadCallback()
      KeyenceModule.Scanner.setConfig(ConfigId.CodeType, this.backupCodeTypeSetting)
    }
  }
}
